module.exports = __webpack_public_path__ + "static/media/contact.2c3e3a6a.webp";